<app-grid>
  <app-cell mobile="0:12">
    <div class="mosaic-container">
      <div class="tile">
        @if (landscape1) {
          <app-responsive-image
            [image]="landscape1"
            [lazyLoad]="lazyLoad"
          ></app-responsive-image>
        } @else {
          <div class="mosaic__bg"></div>
        }
      </div>
      <div class="tile">
        @if (portrait) {
          <app-responsive-image
            [image]="portrait"
            [lazyLoad]="lazyLoad"
          ></app-responsive-image>
        } @else {
          <div class="mosaic__bg"></div>
        }
      </div>
      <div class="tile">
        @if (landscape2) {
          <app-responsive-image
            [image]="landscape2"
            [lazyLoad]="lazyLoad"
          ></app-responsive-image>
        } @else {
          <div class="mosaic__bg"></div>
        }
      </div>
    </div>

  </app-cell>
</app-grid>

